import React from "react"
import { Table, TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, IconButton, FontIcon } from "material-ui"
import TF from "material-ui/Table/TableFooter"
import TableFooter from "../../layout/TableFooter"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { ITimeoffRequestDocument, ETimeoffStatus } from "../../../models"
import { browserHistory } from "react-router"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import { green500 } from "material-ui/styles/colors"
import MultiSupervisorChips from "../../supervisor/MultiSupervisorChips"
import AccountStore from "../../../stores/AccountStore"
import * as timeoffHelper from "../../../helpers/timeoffHelper"

interface IProps {
	unapprovedException: boolean
	showEmployeeExternalId: boolean
	total: number
	limit: number
	offset: number
	limitOption: number[]
	readonly: boolean
	leaveRequests: ITimeoffRequestDocument[]
	onPageClick(offset: number): void
	onLimitChange(limit: number): void
	handleUpdate(leaveRequest: ITimeoffRequestDocument): void
	handleSelect(leaveRequests: ITimeoffRequestDocument[]): void
	handleNotesDrawer(leaveRequestId: string): void
}
interface IState {
	selectedLeaveRequests: ITimeoffRequestDocument[]
	showTable: boolean
}

export default class LeaveTrackingTable extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			selectedLeaveRequests: [],
			showTable: true,
		}
		autobind(this)
	}

	handelOnCellClick(rowNumber, colId) {
		const clickedLeaveRequest = this.props.leaveRequests[rowNumber]
		if (colId === -1) {
			if (!permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.DeleteLeaveTracking) && !permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.EditLeaveTracking)) return
			let selectedLeaveRequests = this.state.selectedLeaveRequests.slice()
			if (this.state.selectedLeaveRequests.find(item => item.Id === clickedLeaveRequest.Id)) {
				selectedLeaveRequests = selectedLeaveRequests.filter(item => item.Id !== clickedLeaveRequest.Id)
			}
			else {
				selectedLeaveRequests.push(clickedLeaveRequest)
			}
			this.setSelectedLeaveRequests(selectedLeaveRequests)
		}
		else {
			permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.ViewEmployees) && colId === 0 ?
				browserHistory.push("/user-details/" + this.props.leaveRequests[rowNumber].UserId + "/timecards") :
				permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.EditLeaveTracking) && this.props.handleUpdate &&
				this.props.handleUpdate(clickedLeaveRequest)
		}
	}

	handleOnRowSelection(result) {
		result === "all" && this.setSelectedLeaveRequests(this.props.leaveRequests.slice())
		result === "none" && this.setSelectedLeaveRequests([])
	}

	setSelectedLeaveRequests(selectedLeaveRequests) {
		this.setState({ selectedLeaveRequests, showTable: false }, () => this.setState({ showTable: true }))
		this.props.handleSelect(selectedLeaveRequests)
	}

	render() {
		return (
			<Table
				allRowsSelected={this.props.leaveRequests.length === this.state.selectedLeaveRequests.length}
				multiSelectable={
					!this.props.readonly && (
						permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.DeleteLeaveTracking) ||
						permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.EditLeaveTracking)
					)
				}
				selectable={
					!this.props.readonly && (
						permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.DeleteLeaveTracking) ||
						permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.EditLeaveTracking)
					)
				}
				onCellClick={this.handelOnCellClick}
				onRowSelection={this.handleOnRowSelection}
			>
				<TableHeader>
					<TableRow>
						<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Name}</TableHeaderColumn>
						{!this.props.unapprovedException &&
							<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Status}</TableHeaderColumn>
						}
						<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Title}</TableHeaderColumn>
						{AccountStore.getSupervisorDirectReportEnabled() &&
							<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Supervisors}</TableHeaderColumn>
						}
						<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Accrual}</TableHeaderColumn>
						<TableHeaderColumn style={{ textAlign: "left", width: 200 }}>{strings.Dates}</TableHeaderColumn>
						<TableHeaderColumn style={{ textAlign: "left" }}>{strings.TotalHours}</TableHeaderColumn>
						<TableHeaderColumn style={{ textAlign: "center" }}>{strings.Applied_Payroll}</TableHeaderColumn>
						<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Applied_Hours}</TableHeaderColumn>
						{AccountStore.getPayRateTimeOffEditAllowed() && <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Pay_Rate}</TableHeaderColumn>}
						<TableHeaderColumn style={{ textAlign: "center" }}>{strings.Notes}</TableHeaderColumn>
					</TableRow>
				</TableHeader>
				<TableBody showRowHover={true} deselectOnClickaway={false}>
					{this.props.leaveRequests.map((row, index) => {
						const dateStr = timeoffHelper.getTimeoffDateStr(row)
						return (
							<TableRow
								data-intercom-target={index === 0 && "LeaveTrackingTable-openItemDetails"}
								key={index}
								selected={this.state.selectedLeaveRequests.find(item => item.Id === row.Id) ? true : false}
							>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>
									{row.EmployeeName}
									<br />
									{this.props.showEmployeeExternalId && row.EmployeeExternalId &&
										<span style={{ color: "rgb(158, 158, 158)", fontSize: 10 }}>Emp #: {row.EmployeeExternalId}</span>
									}
								</TableRowColumn>
								{!this.props.unapprovedException &&
									<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>
										{row.Status === ETimeoffStatus.Requested ? strings.Requested : row.Status === ETimeoffStatus.Approved ? strings.Approved : row.Status === ETimeoffStatus.Applied ? strings.Applied : strings.Denied}
									</TableRowColumn>
								}
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }} title={row.Description}>{row.Description}</TableRowColumn>
								{AccountStore.getSupervisorDirectReportEnabled() &&
									<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>
										<MultiSupervisorChips
											readonly
											hideLabel
											maxCountShow={1}
											selectedSupervisorIds={row.SupervisorIds}
										/>
									</TableRowColumn>
								}
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>{row.AccrualName}</TableRowColumn>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer", width: 200 }} title={dateStr}>
									{dateStr}
								</TableRowColumn>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>{row.TotalHours}</TableRowColumn>
								<TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>
									{row.AppliedInPayroll && <FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />}
								</TableRowColumn>
								<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>{row.AppliedInPayroll && row.AppliedHours}</TableRowColumn>
								{AccountStore.getPayRateTimeOffEditAllowed() &&<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }}>{!!row.PayRate && row.PayRate}</TableRowColumn>}
								<TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>
									<div onClick={e => e.stopPropagation()}>
										<IconButton onClick={() => this.props.handleNotesDrawer(row.Id)}>
											<FontIcon className="fa fa-comments" color={"rgba(97, 97, 97, 0.6)"} />
										</IconButton>
									</div>
								</TableRowColumn>
							</TableRow>
						)
					})}
				</TableBody>
				{this.props.limitOption &&
					<TF>
						<TableFooter
							total={this.props.total}
							offset={this.props.offset}
							limit={this.props.limit}
							limitOptions={this.props.limitOption}
							onPageClick={this.props.onPageClick}
							onLimitChange={this.props.onLimitChange}
						/>
					</TF>
				}
			</Table>
		)
	}
}
